import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { RecitalListTable } from './recital-list-table';

export const RecitalListPage = () => {
  return (
    <div className=''>
      <Link to='/dashboard' className='flex w-max items-center gap-2'>
        <CircleArrowLeft className='size-6' />
        <h2 className='text-2xl font-semibold'>Recital Manager</h2>
      </Link>

      <div className='mt-4 border-t pt-8'>
        <RecitalListTable />
      </div>
    </div>
  );
};
